import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import {
    TaskDefinition,
    useStore,
    useStoreUI,
    useTasksStore
} from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Panel } from '../../Panel/Panel';
import { Flex } from '../../UI/Flex/Flex';
import { TaskChatContainer } from '../TaskChatContainer/TaskChatContainer';
import * as style from './TaskChatPanel.module.less';
interface TaskChatPanelProps {
    taskId: string;
}

export const TaskChatPanel = observer((p: TaskChatPanelProps) => {
    const store = useStore();

    const { taskId } = p;
    const reportId = store.selectedReportId;
    const task: TaskDefinition = useTasksStore().get_task_definition(taskId);
    const [inputText, setInputValue] = useState('');
    const ui = useStoreUI();
    const refInput = useRef<HTMLInputElement>(null);

    const onClickSend = () => {
        if (ui.chatWaitingForResponse) return;

        const input = refInput.current.value;
        if (input.length == 0) return;

        console.log(
            'Sending message to flow_id:',
            task.flow_id,
            'message:',
            input
        );
        const fb = getFirebase();
        const reportId = store.selectedReportId;
        fb.flowtask_add_prompt_job(reportId, taskId, {
            content: input
        });
        setInputValue('');
    };

    const onClickClear = () => {
        if (ui.chatWaitingForResponse) return;

        const areYouSure = window.confirm(
            'Are you sure you want to clear the chat history? This action cannot be undone.'
        );

        if (!areYouSure) return;

        const fb = getFirebase();
        fb.flowtask_add_clear_job(reportId, taskId);
    };
    const waitingForReply = (
        <i>
            <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{
                    animationDuration: '1.25s',
                    width: '20px',
                    height: '20px'
                }}
            ></div>{' '}
        </i>
    );

    const sendButtonContent = (
        <i
            className="bi bi-send"
            onClick={() => {
                onClickSend();
            }}
        >
            {' '}
            Send
        </i>
    );

    const taskState = store.flowTaskState?.[reportId]?.[taskId];
    const isWaitingReply =
        taskState != null &&
        taskState?.status != 'completed' &&
        taskState?.status != 'failed';

    const clearButtonContent = (
        <i
            className="bi bi-trash"
            style={{ color: 'black' }}
            onClick={() => {
                onClickClear();
            }}
        ></i>
    );

    const sendButton = (
        <Button className={style.sendButton}>
            {isWaitingReply ? waitingForReply : sendButtonContent}
        </Button>
    );
    const clearButton = (
        <Button className={style.clearButton}>{clearButtonContent}</Button>
    );

    const taskTitle = (
        <div className={style.taskTitle}>
            <span className="taskSectionTitle">Section Name / </span>
            <span className="taskNameTitle">{task.name}</span>
        </div>
    );
    return (
        <Panel fillCell={true} className={style.customShadow}>
            <Flex direction="column" fillCell={true}>
                {clearButton}
                {taskTitle}
                <div className={style.messages}>
                    <TaskChatContainer
                        showWaitingAnimation={isWaitingReply}
                        reportId={store.selectedReportId}
                        taskId={taskId}
                    />
                </div>
                <Flex className={style.inputLineOffset}>
                    <div className={style.input}>
                        <input
                            ref={refInput}
                            type="text"
                            value={inputText}
                            placeholder="Enter a question"
                            autoFocus={true}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    onClickSend();
                                }
                            }}
                            onChange={e => {
                                setInputValue(e.currentTarget.value);
                            }}
                        ></input>
                    </div>
                    {sendButton}
                </Flex>
            </Flex>
        </Panel>
    );
});
